import { render, staticRenderFns } from "./single-selector.vue?vue&type=template&id=bda7ac0c&scoped=true&"
import script from "./single-selector.vue?vue&type=script&lang=js&"
export * from "./single-selector.vue?vue&type=script&lang=js&"
import style0 from "./single-selector.vue?vue&type=style&index=0&id=bda7ac0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda7ac0c",
  null
  
)

export default component.exports